// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"location-setting"},"nodeName":"g","children":[{"attributes":{"id":"fill2","fill":"transparent","d":"M21 18C21 19.6569 19.6569 21 18 21C16.3431 21 15 19.6569 15 18C15 16.3431 16.3431 15 18 15C19.6569 15 21 16.3431 21 18Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M11 22C11 22 3 16.4992 3 10C3 5.58172 6.58172 2 11 2C15.4183 2 19 5.58172 19 10M14 10C14 11.6569 12.6569 13 11 13C9.34315 13 8 11.6569 8 10C8 8.34315 9.34315 7 11 7C12.6569 7 14 8.34315 14 10Z","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M17.9999 15V13.75M17.9999 15C16.3431 15 14.9999 16.3431 14.9999 18C14.9999 19.6569 16.3431 21 17.9999 21M17.9999 15C19.6568 15 20.9999 16.3431 20.9999 18C20.9999 19.6569 19.6568 21 17.9999 21M17.9999 21V22.25M15.4019 16.5L14.3193 15.875M20.598 19.5L21.6806 20.125M20.598 16.5L21.6806 15.875M15.4019 19.5L14.3193 20.125","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-location-setting')
export default class LocationSettingIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'location-setting',
    }
  }
}
